import React from "react";

import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const Sku = ({ sku, clientId, onClick }) => {
  const theme = useTheme();

  return (
    <Box
      borderRadius="8px"
      boxShadow={theme.shadows[4]}
      onClick={() => onClick(sku)}
      paddingTop="2px"
      paddingBottom="2px"
      paddingLeft="4px"
      paddingRight="4px"
      sx={{
        cursor: "pointer",
        bgcolor: "#ffffff",
        "&:hover": { bgcolor: theme.palette.primary.light },
        display: "flex",
      }}
    >
      {sku.image && (
        <img
          src={sku.image}
          width="32px"
          height="auto"
        />
      )}
      <Box sx={{ width: "100%" }}>
        <Box style={styles.nameContainer}>
          <Typography sx={styles.skuName}>{sku.name}</Typography>
          {sku.packSize && (
            <Typography style={styles.packSize}>{sku.packSize}</Typography>
          )}
        </Box>
        {sku.name_fr && (
          <Typography style={styles.skuName_fr}>{sku.name_fr}</Typography>
        )}
        <Box style={styles.codeContainer}>
          {sku.upc && (
            <Typography style={styles.upc}>UPC: {sku.upc}</Typography>
          )}
          {sku.clientCode && (
            <Typography style={styles.clientCode}>
              Client Code: {sku.clientCode}
            </Typography>
          )}
        </Box>
        <Box style={styles.roiContainer}>
          {sku.roiDistribution && (
            <Typography style={styles.roiText}>
              Distribution ROI: ${sku.roiDistribution}
            </Typography>
          )}
          {sku.roiOOS && (
            <Typography style={styles.roiText}>
              OOS ROI: ${sku.roiOOS}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  nameContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  skuName: {
    fontSize: "12px",
    fontWeight: "bold",
  },
  skuName_fr: {
    fontSize: "12px",
  },
  packSize: {
    fontSize: "12px",
  },
  codeContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  upc: {
    fontSize: "12px",
  },
  clientCode: {
    fontSize: "12px",
  },
  roiContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  roiText: {
    fontSize: "12px",
  },
};

export default Sku;
